export default class bstMessageKeys extends HTMLElement {
	connectedCallback() {
		const template = document.createElement('template');
		const lightDom = this.innerHTML;

		const shadowHtml = `<style>
					:host {
						/*position: absolute;*/
						z-index: 999;
					}
	
					code {
						display: inline-block;
						background-color: lightcoral;
						padding: 0;
						font-size: 12px;
						font-weight: normal;
						line-height: 18px;
						overflow: hidden;
						max-width: 16px;
						height: 16px;
						border-radius: var(--RADIUS_circle);
						cursor: copy;
						color: rgba(255, 255, 255, 0);
					}
						
					code.is-open {
						transition: max-width .5s ease-in-out, padding .5s ease-in, color ease-in .5s;
						padding: 4px;
						max-width: 700px;
						height: auto;
						color: rgba(255, 255, 255, 1);
						border-radius: 6px; /* lokaler radius */
						/*cursor: zoom-out;*/
					}
				</style>
				<code class="is-open">${lightDom}</code>
			`;

		// template.innerHTML = new Sanitizer().sanitizeFor('div', shadowHtml).innerHTML;
		template.innerHTML = this.sanitizeEvilHtml(shadowHtml);

		const clone = document.importNode(template.content, true);
		if (!this.shadowRoot) {
			this.attachShadow({ mode: 'open' });
			this.shadowRoot.appendChild(clone);
		}

		this.addEventListener('click', async (event) => {
			event.preventDefault();
			event.stopPropagation();
			event.stopImmediatePropagation();

			const messageKey = lightDom.replaceAll('{', '').replaceAll('}', '');
			await navigator.clipboard.writeText(messageKey);

			// Add visual feedback for copy action
			const codeElement = this.shadowRoot.querySelector('code');
			const originalBackground = codeElement.style.backgroundColor;

			// Briefly change the background color to indicate successful copy
			codeElement.style.backgroundColor = '#4CAF50'; // Green color for success

			// Reset back to original color after a short delay
			setTimeout(() => {
				codeElement.style.backgroundColor = originalBackground;
			}, 300); // 300ms flash
		});
	}

	sanitizeEvilHtml(string) {
		// Das muss nochmal ein richtiger sanatizer werden
		return String(string).replace(
			/<script|onerror|onload|onmouseover|onmouseout|onpagehide|onpageshow|onmessage|onhashchange|onbeforeunload|onpopstate|onresize|onunload/g,
			'',
		);
	}

	disconnectedCallback() {}
}
